import { PermittingSection, ZoningSection } from './workflow-data.interface';

export const PERMITTING_INFO_DATES: Array<keyof PermittingSection> = [
  'e911AddressValidation',
  'jurisdictionAuditComplete',
  'prelimCDsReviewedPermitting',
  'finalCDsReviewedPermitting',
  'ZBPServicesFormCompleted',
];

export const ZONING_INFO_DATES: Array<keyof ZoningSection> = [
  'BPReceived',
  'BPSubmitted',
  'BPExpiration',
  'zoningAppDeemedComplete',
  'zoningApproved',
  'zoningSubmitted',
];
